import React, { useState, useEffect } from 'react'
import { Input, Grid, Checkbox, Row } from 'rsuite'
import { isValidators } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { set } from 'nprogress'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'

export default function SearchTagForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [isComment, setIsComment] = useState(schema.value ? true : false)
  const [comment, setComment] = useState(schema.value || '')

  return (
    <Grid>
      <Row style={{ marginBottom: 10 }}>
        <Checkbox
          checked={isComment}
          onChange={(_, checked) => {
            setIsComment(checked)
            if (!checked) {
              setComment('')
              setValue(schema.name, '')
            }
          }}
        >
          {schema.label}
        </Checkbox>
      </Row>
      {errors[schema.name] && (
        <Row style={{ marginBottom: 10 }}>
          <ErrorMessage error={errors[schema.name]} />
        </Row>
      )}

      {isComment && (
        <Row>
          <Input
            componentClass="textarea"
            rows={2}
            name={schema.name}
            value={comment}
            placeholder={schema.hint}
            inputRef={register(isValidators(schema.validators))}
            onChange={(value) => {
              setComment(value)
            }}
          />
        </Row>
      )}
    </Grid>
  )
}
